import { Field, FieldProps } from 'formik';
import UrlInput from '../UrlInput';

type UrlInputFormikProps = {
  name: string;
  imageFieldName: string;
  isDisabled?: boolean;
  label?: string;
  rows?: number;
  maxRows?: number;
  isRequired?: boolean;
  placeholder?: string;
};

const UrlInputFormik = (props: UrlInputFormikProps) => {
  return (
    <Field name={props.name}>
      {(field: FieldProps) => (
        <div>
          <label htmlFor={props.name} className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            {props.label}
          </label>

          <UrlInput
            name={props.name}
            isDisabled={props.isDisabled}
            isRequired={props.isRequired}
            placeholder={props.placeholder}
            value={{ url: field.field.value, imageUrl: field.form.values[props.imageFieldName] }}
            onChange={(newValue) => {
              field.form.setFieldValue(props.name, newValue.url);
              field.form.setFieldValue(props.imageFieldName, newValue.imageUrl);
            }}
            onBlur={field.field.onBlur}
          />

          {field.form.errors[field.field.name] && field.form.touched[field.field.name] && (
            <p className="text-red-700 text-sm mt-1">{field.form.errors[field.field.name]}</p>
          )}
        </div>
      )}
    </Field>
  );
};

export default UrlInputFormik;
